// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9993) return "static/chunks/9993-ab3cd337a5e990d6.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2497":"e9d4f003","9883":"f28261c4"}[chunkId] || chunkId) + "." + {"2497":"b7f6246f71f43f68","6554":"9a9f8cb36d05db0a","8637":"f682d3baff50bd8f","9472":"a133256b96c1823c","9883":"4bdd2163d74b6a0b"}[chunkId] + ".js";
};